import { useState } from 'react';
import { MessageSquare, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const whatsappNumber = '919876543210';
  const defaultMessage = 'Hi, I visited the Anexi Consulting website and would like to know more about your services.';

  return (
    <div className="fixed bottom-6 left-6 z-40 hidden lg:block" data-testid="whatsapp-widget-button">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 10 }}
            className="absolute bottom-16 left-0 bg-white rounded-2xl shadow-2xl border border-[rgba(61,28,17,0.08)] w-[300px] overflow-hidden"
          >
            <div className="bg-[#25D366] px-5 py-4">
              <div className="flex justify-between items-center">
                <div>
                  <p className="text-white font-semibold text-sm">Anexi Consulting</p>
                  <p className="text-white/80 text-xs">Typically replies instantly</p>
                </div>
                <button onClick={() => setIsOpen(false)} className="text-white/80 hover:text-white">
                  <X size={16} />
                </button>
              </div>
            </div>
            <div className="p-4">
              <div className="bg-[#FAF5EF] rounded-xl p-3 mb-4">
                <p className="text-sm text-[#2D2019]">Hello! How can we help you today?</p>
              </div>
              <a
                href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center bg-[#25D366] text-white py-2.5 rounded-xl text-sm font-medium hover:bg-[#20BD5A] transition-colors"
              >
                Start Chat
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-shadow hover:scale-105 active:scale-95"
        aria-label="Chat on WhatsApp"
      >
        <MessageSquare size={24} className="text-white" />
      </button>
    </div>
  );
};

export default WhatsAppWidget;
